<template>
    <b-button
        :class="[
            withSpace ? 'mr-1' : '',
            !clickable ? 'lx-responsive-button-unclickable' : '',
        ]"
        :href="href"
        :to="to"
        :disabled="disabled || busy"
        :variant="variant"
        :size="size"
        v-on="inputListeners"
        v-b-modal="modal"
    >
        <b-spinner small v-if="busy"></b-spinner>
        <div class="d-flex flex-nowrap" v-else>
            <div v-if="icon" class="lx-responsive-button-icon" :class="{'lx-responsive-button-icon-slash': slash}">
                <font-awesome-icon :icon="icon" size="lg"></font-awesome-icon>
            </div>
            <span v-if="hasDefaultSlot" :class="{'lx-responsive-button-label': !!responsiveness, 'ml-1': icon}">
                <slot></slot>
            </span>
        </div>
    </b-button>
</template>

<script>
    export default {
        name: 'ResponsiveButton',
        props: {
            href: {
                type: String,
                default: null,
            },
            to: {
                type: [String, Object],
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            icon: [Object, Array, String],
            slash: {
                type: Boolean,
                default: false,
            },
            modal: {
                type: String,
                default: null,
            },
            variant: {
                type: String,
                default: null,
            },
            busy: {
                type: Boolean,
                default: false,
            },
            withSpace: {
                type: Boolean,
                default: true,
            },
            responsiveness: {
                type: Boolean,
                default: true,
            },
            clickable: {
                type: Boolean,
                default: true,
            },
            size: {
                type: String,
                default: ''
            }
        },
        computed: {
            hasDefaultSlot() {
                return !!this.$slots.default;
            },
            inputListeners() {
                // We add all the listeners from the parent
                return Object.assign({}, this.$listeners);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    @include media-breakpoint-down(md) {
        .lx-responsive-button-label {
            display: none;
        }
    }

    .lx-responsive-button-unclickable {
        pointer-events: none;
    }

    .lx-responsive-button-icon {
        display: inline-block;
    }

    .lx-responsive-button-icon-slash {
        position: relative;
    }

    .lx-responsive-button-icon-slash::after {
        content: '';
        position: absolute;
        top: -10%;
        left: 50%;
        border-left: 2px solid #ffffff;
        outline: 1px solid #6c757d;
        height: 120%;
        transform: rotate(-45deg);
        transform-origin: center;
    }
</style>
